var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAssignmentInd48Filled = function SvgIconAssignmentInd48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 11.3h-1.7v-.1a2.9 2.9 0 0 0-2.9-2.9H19.2a2.9 2.9 0 0 0-2.9 2.9v.1h-1.7a5.3 5.3 0 0 0-5.3 5.3v17.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.302 5.302 0 0 0-5.35-5.3ZM19.65 13v-1.3h8.6v2.6h-8.6V13Zm4.3 5.65a4.7 4.7 0 1 1-4.7 4.7 4.71 4.71 0 0 1 4.7-4.7Zm7.7 16.7h-15.4v-3.36a3.15 3.15 0 0 1 3.14-3.14h9.12a3.15 3.15 0 0 1 3.14 3.14v3.36Z",
    fill: "current"
  })));
};
export default SvgIconAssignmentInd48Filled;